import React from 'react';
import { Link } from 'react-router-dom';

const DEPENDENCIES = [
  '@d11/react-native-fast-image',
  '@livekit/react-native',
  '@livekit/react-native-webrtc',
  '@notifee/react-native',
  '@react-native-async-storage/async-storage',
  '@react-native-clipboard/clipboard',
  '@react-native-community/geolocation',
  '@react-native-firebase/app',
  '@react-native-firebase/messaging',
  '@react-navigation/native',
  '@react-navigation/native-stack',
  '@supabase/supabase-js',
  'aes-js',
  'base64-arraybuffer',
  'google-auth-library',
  'google-libphonenumber',
  'livekit-client',
  'lodash.isequal',
  'lottie-react-native',
  'react',
  'react-native',
  'react-native-callkeep',
  'react-native-contacts',
  'react-native-encrypted-storage',
  'react-native-fs',
  'react-native-gesture-handler',
  'react-native-get-random-values',
  'react-native-image-crop-picker',
  'react-native-image-picker',
  'react-native-immersive-mode',
  'react-native-incall-manager',
  'react-native-orientation-locker',
  'react-native-permissions',
  'react-native-phone-input',
  'react-native-reanimated',
  'react-native-safe-area-context',
  'react-native-screens',
  'react-native-sensors',
  'react-native-sound',
  'react-native-splash-screen',
  'react-native-url-polyfill',
  'react-native-vector-icons',
  'react-native-version',
  'react-native-voip-push-notification',
  'react-native-wheel-scrollview-picker',
  'uuid',
];

const Libraries: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="page-title">Open Source Libraries</h1>
        <p className="page-subtitle">
          Thank you to all the maintainers and contributors. Bye For Now would not be possible without you.
        </p>
        <div className="libraries-grid">
          {DEPENDENCIES.map((lib) => (
            <div key={lib} className="library-item">
              <code>{lib}</code>
            </div>
          ))}
        </div>
        <Link to="/" className="page-back-link">
          ← Back to home
        </Link>
      </div>
    </div>
  );
};

export default Libraries;
